const EMPTY_DISPLAY = '—';

export function buildSiteDetailPath(siteId: string): string {
  return `/sites/${siteId}`;
}

export function buildAssetDetailPath(assetId: string): string {
  return `/assets/${assetId}`;
}

export function normalizeDisplayText(
  value: string | null | undefined,
): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function toEmptyDisplay(value: string | null | undefined): string {
  return normalizeDisplayText(value) ?? EMPTY_DISPLAY;
}

export function resolveLinkedHref(
  id: string | null | undefined,
  title: string | null | undefined,
  buildPath: (id: string) => string,
): string | null {
  const normalizedId = normalizeDisplayText(id);
  const normalizedTitle = normalizeDisplayText(title);

  if (!normalizedId || !normalizedTitle) {
    return null;
  }

  return buildPath(normalizedId);
}
